// noinspection JSUnusedGlobalSymbols

'use client';

import {Observable} from 'rxjs';
import {io, Socket} from 'socket.io-client';
import {Socket as ioSocketClient} from 'socket.io-client';
import _ from 'lodash';

import {$e, $store} from "../global";
import {config} from '@isudio/config';
import {UserPresence} from '@isudio/data';
import {SocketEvents} from '../constants/socket.events';

export class SocketService {
  socket: Socket;
  socketClient: ioSocketClient;

  constructor() {
  }

  get socketId(): string {
    return _.get(this.socketClient, 'id', null);
  }

  get connected(): boolean {
    return _.get(this.socketClient, 'connected', false);
  }

  public async listen() {
    const socketUrl = config.socket.url;

    this.socketClient = io(socketUrl, {
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 100,
      transports: ['websocket'],
      query: {
        token: _.get($store, 'User.session.accessToken.token'),
      },
    });

    this.socketClient.on('connect', this.onConnect.bind(this));
    this.socketClient.on('reconnect', this.onReconnect.bind(this));
    this.socketClient.on('error', this.onError.bind(this));
    this.socketClient.on('reconnect_error', this.onError.bind(this));
    this.socketClient.on('reconnect_failed', this.onError.bind(this));
    this.socketClient.on('connect_error', this.onError.bind(this));

    _.each(SocketEvents.subscribe, (o: any) => {
      if (_.has(o, 'event')) {
        this.subscribe(o.event);
      } else {
        this.loop(o);
      }
    });
  }

  private subscribe(event: string): void {
    this.get(event).subscribe((payload: any) => {
      if (_.has(payload, 'action')) {
        const e = _.find($e.events, { name: payload.action });
        if (e) {
          $e.$b(e, payload);
        }
      } else {
        _.logEvent?.(event);
        _.logInfo?.(_.get(payload, 'data'));
      }
    });
  }

  private loop(o: any): void {
    _.each(o, (e: any) => {
      if (_.has(e, 'event')) {
        this.subscribe(e.event);
      }
    });
  }

  private onConnect(): void {
    if (this.socketClient?.connected) {
      $e.$b($e.events.socketConnected, this.socketClient.id);
      this.triggerPresenceChanged();
    }
  }

  private onReconnect(): void {
    if (this.socketClient?.connected) {
      $e.$b($e.events.socketReconnected, this.socketClient.id);
      this.triggerPresenceChanged();
    }
  }

  private onError(): void {
    $e.$b($e.events.socketDisconnected);
    this.triggerPresenceChanged();
  }

  private triggerPresenceChanged(): void {
    $e.$b($e.events.presenceChanged, {
      data: {
        uid: _.get($store.User, 'user.uid'),
        did: _.get($store.Device, 'data.did'),
        session: {
          socketId: this.socketClient.id,
          presence: UserPresence.online,
        },
      },
    });
  }

  public async send(key: string, data: any): Promise<void> {
    this.socketClient?.emit(key, data);
  }

  public get(key: string): Observable<any> {
    return new Observable((observer) => {
      if (!this.socketClient) return;

      const handler = (data: any) => observer.next(data);
      this.socketClient.on(key, handler);

      return () => {
        this.socketClient?.off(key, handler);
      };
    });
  }
}